import React from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { Button, StackView, Divider, Typography } from '@telus-uds/components-web';


import {
  Backdrop,
  ModalMain,
  ModalInner,
  ModalMessageMain,
  ModalHeading,
  ButtonContainer
} from './css';

const BrpConfirmationBox = ({ handleSubmitAnotherBrpRequest }) => {
  const history = useHistory();

  const handleGoHome = () => {
    history.push('/');
  };
  return (
    <Backdrop>
      <ModalMain>
        <ModalInner>
          <ModalMessageMain>
            <ModalHeading>Your request has been submitted.</ModalHeading>
            <StackView space={2}>
              <Divider />
              <div style={{ margin: '1rem 0' }}>
                <Typography block>
                  Thank you for submitting your NTA Request to Business Resource
                  Planning.
                </Typography>
              </div>
              <div style={{ margin: '0.5rem 0' }}>
                <Typography block>
                  Our team is operational Monday-Friday, 8-4pm (MST) (7-3pm
                  (PST)), supporting All TELUS regions, excluding Quebec and
                  Labrador.
                </Typography>
              </div>
              <div style={{ margin: '0.5rem 0' }}>
                <Typography block>
                  You should expect a response to your inquiry within 1 - 2
                  business days.
                </Typography>
              </div>
              <div style={{ margin: '0.5rem 0' }}>
                <Typography block>
                  Should your submission NOT meet the criteria for NBD/BCX
                  Resource planning function, it may be rejected.
                </Typography>
              </div>
              <div style={{ margin: '0.5rem 0' }}>
                <Typography block>
                  For immediate assistance please call 1-855-200-8882 and follow
                  the queue prompts.
                </Typography>
              </div>
              <Typography block>TELUS ® BRM – Business Resource Management</Typography>
              <Typography block>the future is friendly ®</Typography>
            </StackView>
          </ModalMessageMain>
        </ModalInner>
        <ButtonContainer>
          <Button onClick={handleSubmitAnotherBrpRequest}>
            Submit another request
          </Button>
          <Button variant={{ priority: 'low' }} onClick={handleGoHome}>
            Go to home
          </Button>
        </ButtonContainer>
      </ModalMain>
    </Backdrop>
  );
};

BrpConfirmationBox.propTypes = {
  handleSubmitAnotherBrpRequest: PropTypes.func.isRequired
};

export default BrpConfirmationBox;
